import type { FC, PropsWithChildren } from 'react'
import React, { createContext, useContext } from 'react'

/**
 * 锚点 hash 上下文
 * 从 pageStack atom 获取 hash（builder、runner modal/drawer）
 * 未提供时 fallback 到 window.location.hash（runner 页面类型 navigate 时 hash 在 URL 上）
 */
const AnchorHashContext = createContext<string | undefined>(undefined)

export const AnchorHashProvider: FC<PropsWithChildren<{ value?: string }>> = ({ value, children }) => (
    <AnchorHashContext.Provider value={value}>{children}</AnchorHashContext.Provider>
)

export const useAnchorHashContext = () => useContext(AnchorHashContext)
